import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Logout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();
  const localUser = (() => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  })();

  const handleYes = () => {
    logout();
    localStorage.removeItem("user");
    navigate("/", { replace: true });
  };

  const handleNo = () => {
    const fromRoute = typeof location.state?.from === "string" ? location.state.from : "";
    if (fromRoute && fromRoute !== "/logout") {
      navigate(fromRoute, { replace: true });
      return;
    }

    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    const fallbackModuleId = parseInt(localUser?.moduleId, 10);
    const fallbackRoute = fallbackModuleId === 10 ? "/guesthouse/pending-bookings" : "/profile";
    navigate(fallbackRoute, { replace: true });
  };

  return (
    <section className="container" style={{ maxWidth: "760px" }}>
      <h3 className="mb-4">Logout</h3>

      <div className="card shadow-sm border-0">
        <div className="card-body py-5 text-center">
          <p className="fs-5 mb-4">Are You Sure You Want To Logout?</p>

          <div className="d-flex justify-content-center gap-3">
            <button type="button" className="btn btn-success btn-lg px-4" onClick={handleYes}>
              Yes
            </button>
            <button type="button" className="btn btn-danger btn-lg px-4" onClick={handleNo}>
              No
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
